import { render, staticRenderFns } from "./soalbmtk.vue?vue&type=template&id=5b1d4602"
import script from "./soalbmtk.vue?vue&type=script&lang=js"
export * from "./soalbmtk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports